export default __webpack_public_path__ + "static/media/ic-working-hrs.56079f51.svg";